import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { AspectRatioString } from '@fcom/common';
import { CmsArticle, CmsImageData, CmsMedia, CmsQueryListItem, CmsTeaserCard } from '@fcom/core-api';

@Component({
  selector: 'fin-teaser-card',
  templateUrl: './teaser-card.component.html',
  styleUrls: ['./teaser-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TeaserCardComponent {
  aspectRatio = input<AspectRatioString>('16x9');
  content = input.required<CmsQueryListItem | CmsArticle | CmsTeaserCard>();

  linkClicked = output();

  emitClick(): void {
    this.linkClicked.emit();
  }

  getPics(media: CmsMedia[]): CmsImageData[] {
    return media.filter((m) => 'responsiveImageLinksData' in m) as CmsImageData[];
  }
}
